module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "part-title",
    attrs: {
      "id": "pt-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Introduction")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-1"
    }
  }, [_vm._v("NAME AND CANONICITY")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Deuteronomy is the fifth book of the canonical Hebrew Scriptures/Old Testament (OT). In Jewish tradition the first five books are “The Torah” (Sirach, "), _c('em', [_vm._v("Prologue")]), _vm._v("), going otherwise by their Latin name, "), _c('em', [_vm._v("Pentateuch")]), _vm._v(". Greek πεντάτευχος (= “five rolls”) is an adaptation of the Hebrew "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("חֲמִשָּׁה חֻמְשֵׁי הַתּוֹרָה")]), _vm._v(", meaning “five-fifths of the Law” ("), _c('em', [_vm._v("JE")]), _vm._v(" 9:589). A Dead Sea Scroll fragment (1Q30:1 line 4) has turned up the expression ‏"), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("[ס]פרים חומשים")]), _vm._v(", which may denote either the five books of the Torah or the five books of the Psalter (Barthélemy and Milik 1955, 132–33).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is not known when the division into five books occurred, although it is generally thought to have been long before the Second Temple/New Testament (NT) period ("), _c('em', [_vm._v("EncJud")]), _vm._v(" 13:232). In the Talmud ("), _c('em', [_vm._v("b. B. Bat")]), _vm._v(". 14b–15a), the author of this work, except perhaps for the last eight verses of Deuteronomy, is said to have been Moses. These concluding verses report Moses’ death, for which reason certain rabbis said they must have been written by Joshua. Already in 1 Kgs 2:3 and 2 Kgs 14:6 are references to a written “law of Moses” (cf. Josh 8:31; 23:6; Ezra 3:2). Mosaic authorship of Deuteronomy is affirmed by Josephus, although with the qualification that Moses left things in a scattered condition ("), _c('em', [_vm._v("Ant")]), _vm._v(". 4.196–97).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("The name "), _c('em', [_vm._v("Deuteronomion")]), _vm._v(" in the Greek Septuagint (LXX) derives from τὸ δευτερονόμιον το"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ῦ")]), _vm._v("το in LXX 17:18, which is its rendering of "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־מִשְׁנֵה הַתּוֹרָה הַזֹּאת")]), _vm._v(". The LXX translator(s) took the expression to mean “this second law,” whereas T"), _c('sup', [_vm._v("Onq")]), _vm._v(" translates “a copy of this law” (cf. Josh 8:32), now the generally accepted interpretation. Hebrew "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מִשְׁנֶה")]), _vm._v(" can mean “double, second, copy.” Mishnah "), _c('em', [_vm._v("Sanh")]), _vm._v(". 2:4 says the king was to write for himself “a scroll of the law,” which it takes to mean “an additional scroll” (Blackman 1977, 4:244). The Qumran "), _c('em', [_vm._v("Temple ")])]), _c('em', [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Scroll")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v(" (11QT 56:21) simply has “this law,” instead of “a copy of this law,” removing the ambiguity (Yadin 1983, 1:345; 2:254). In Rabbinical Hebrew Deuteronomy is called "), _c('em', [_vm._v("Mishneh Torah")]), _vm._v(" ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("תּוֹרָה מִשְׁנֵה")]), _vm._v("), which means “repeated law” (Weinfeld, "), _c('em', [_vm._v("EncJud")]), _vm._v(" 13:232). This name and the LXX name are therefore not inappropriate, since Deuteronomy repeats earlier law from Exodus, and in 28:69(29:1) the Deuteronomic covenant is distinguished from the covenant made at Horeb (Sinai). Luther took "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מִשְׁנֵה תּוֹרָה")]), _vm._v(" to mean “second Law,” but said there was no difference between this law and the law given at Horeb. Latin "), _c('em', [_vm._v("Deuteronomium")]), _vm._v(" of the Vulgate (Vg) comes into English as “Deuteronomy.” The Hebrew name for Deuteronomy is "), _c('em', [_vm._v("Debarim")]), _vm._v(" ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("דְּבָרִים")]), _vm._v("), “(the) Words,” taken—as elsewhere in the Pentateuch—from the opening words of the book: “These are the words” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֵלֶּה הַדְּבָרִים")]), _vm._v(").")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-2"
    }
  }, [_vm._v("TEXT AND VERSIONS")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The text of Deuteronomy is relatively good, only occasionally requiring correction from the ancient Versions (Driver 1895, xcv). It has none of the problems found in Samuel, Hosea, Jeremiah, and certain other OT books. Difficult or problematic readings occur mainly in the poetry of chapters 32 and 33, and even then, these are not many.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Hebrew Masoretic Text (MT) survives in modern times in the Leningrad Codex (M"), _c('sup', [_vm._v("L")]), _vm._v("), dated ca. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 1010, and is the text on which "), _c('em', [_vm._v("BH")]), _c('sup', [_vm._v("3")]), _vm._v(" and "), _c('em', [_vm._v("BHS")]), _vm._v(" are based (Sanders and Beck 1997). It is also the text on which "), _c('em', [_vm._v("Biblia Hebraica Quinta (BHQ)")]), _vm._v(" and the "), _c('em', [_vm._v("Oxford Hebrew Bible")]), _vm._v(", both currently in preparation, will be based. Deuteronomy in "), _c('em', [_vm._v("BHQ")]), _vm._v(" has been prepared by Carmel McCarthy; for a summary of her work on the text, see McCarthy 2007. M"), _c('sup', [_vm._v("L")]), _vm._v(" is the oldest complete manuscript of the Hebrew Bible in existence, housed in the Russian National Library in St. Petersburg. A fascimile was published recently by David Noel Freedman et al. (1998). The other important medieval manuscript of the Hebrew Bible is the Aleppo Codex (M"), _c('sup', [_vm._v("A")]), _vm._v("), dated to the tenth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" This codex has been published in a facsimile edition by Moshe Goshen-Gottstein (1976) and is the text being used in the "), _c('em', [_vm._v("Hebrew University Bible (HUB)")]), _vm._v(". The Aleppo Codex is only 70 percent complete, however, a number of folios having been lost as a result of the Aleppo riots of 1948. Most of the Pentateuch is missing. The codex presently begins with the last word of Deut 28:17, “and your baking bowl” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וּמִשְׁאַרְתֶּךָ")]), _vm._v("), after which the remainder of Deuteronomy is preserved.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("The LXX of the Pentateuch, translated probably in the early or middle third century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.")]), _vm._v(" by Jews in Alexandria, is a relatively good translation of the Hebrew text (Eissfeldt 1965, 604–5, 702–4; Fohrer 1968, 508). Variants in Deuteronomy are largely the sudden and frequent changes between second singular ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("and second plural (both “you”) in the speeches of Moses (the so-called "), _c('em', [_vm._v("Numeruswechsel")]), _vm._v(") and minor differences bearing little or not at all on the sense. There are cases where the LXX translator seems not to have correctly understood the Hebrew, e.g., in 28:5 he mistranslates "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מִשְׁאַרְתֶּךָ")]), _vm._v(" (“your kneading bowl”) with τὰ ἐγκαταλείμματά σου (“your reserve”), and in 28:20 he translates "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־הַמְּאֵרָה אֶת־הַמְּהוּמָה וְאֶת־הַמִּגְעֶרֶת")]), _vm._v(" (“curse, panic, and rebuke”) with τὴν ἔνδειαν καὶ τὴν ἐκλιμίαν καὶ τὴν ἀνάλωσιν (“poverty and famine and destruction”), which are not quite right.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The LXX appears not to manifest any anti-anthropomorphic bias in its translation, as might be expected (Wittstruck 1976). Fritsch (1943) claimed for the Greek Pentateuch numerous anti-anthropomorphisms, but this thesis has been refuted by Orlinsky (1944) and Wittstruck (1976). It finds little support in Deuteronomy, and of the examples cited by Fritsch many occur not in the law code, but in the poetry of chapters 32 and 33, where unusual coinages might be expected. The LXX text of Deuteronomy gets full and detailed discussion in Wevers 1978 and 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A couple of LXX readings in Deut 32:8 and 43 (the Song of Moses) have taken on new importance in light of Dead Sea Scroll readings, which vindicate them partially or wholly against readings in MT (see below).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Samaritan Pentateuch (Sam), dating in all likelihood from a time soon after the Pentateuch was canonized in ca. 400 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.")]), _vm._v(", contains a reported six thousand divergencies from the MT, most of which are orthographic (Eissfeldt 1965, 695; Fohrer 1968, 505; Waltke, "), _c('em', [_vm._v("ABD")]), _vm._v(", 5:932). Roughly one-third agree with the LXX against MT. While some do correct or improve readings of MT, the vast majority are insignificant differences in spelling and grammar that do not affect the sense. Waltke ("), _c('em', [_vm._v("ABD")]), _vm._v(", 5:938) says the Sam is therefore of little value in determining original readings. Occasionally variants are of substance. One is the substitution of “Gerizim” in Deut 27:4 for “Ebal” in MT. This could be a deliberate change giving prominence to the mountain on which the Samaritan temple was located, although Eissfeldt (1965, 216 n. 9, 695) and others think the reading is more likely an anti-Samaritan polemic in light of the schism between Samaritans and Jews in the fourth century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.")]), _vm._v(" (cf. Josephus "), _c('em', [_vm._v("Ant")]), _vm._v(". 13.74–79), thus a change not in Sam, but in MT. For discussion on the Samaritan Pentateuch, see J. MacDonald in "), _c('em', [_vm._v("EncJud")]), _vm._v(" 13:264–68; B. Waltke in "), _c('em', [_vm._v("ABD")]), _vm._v(", 5:932–40; Crawford 2005b:131–32.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("The Targums, which are Aramaic paraphrases of OT books written in Palestine in the early centuries of the Christian Era, fulfill a need similar to what the LXX filled in Egypt, viz., to enable non-Hebrew-speaking Jews to understand the Hebrew Bible. They are literal renditions of the biblical text adding "), _c('em', [_vm._v("halakhic")]), _vm._v(" interpretation and "), _c('em', [_vm._v("aggadic")]), _vm._v(" embellishment. The authoritative Targum on the Torah is "), _c('em', [_vm._v("Targum Onqelos")]), _vm._v(" (T"), _c('sup', [_vm._v("Onq")]), _vm._v("), dated in the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(", but in ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Deuteronomy one can also consult readings in "), _c('em', [_vm._v("Targum Neofiti")]), _vm._v(" (T"), _c('sup', [_vm._v("Nf")]), _vm._v(") and "), _c('em', [_vm._v("Targum Pseudo-Jonathan")]), _vm._v(" (T"), _c('sup', [_vm._v("PsJ")]), _vm._v(").")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-3"
    }
  }, [_vm._v("QUMRAN SCROLLS")])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Numerous texts of Deuteronomy have been found at Khirbet Qumran: biblical fragments, excerpted texts, selected verses on "), _c('em', [_vm._v("mezuzot")]), _vm._v(" and phylacteries, and passages incorporated into sectarian and other nonbiblical documents. According to García Martínez (1994, 66), there are thirty-two extant fragments of Deuteronomy from the Judean Desert, all prior to "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 70. Crawford (2005a, 316) says the total is thirty-four or thirty-five, which includes one Greek Deuteronomy fragment and one Hebrew fragment each from Wadi Murabba"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ʿ")]), _vm._v("at, Na"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("al "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _vm._v("ever/Wadi Seiyal, and Masada. Deuteronomy is second only to the book of Psalms in numbers of copies turning up at Qumran (Crawford 2005b, 127). There is no complete manuscript to be compared with the celebrated Isaiah Scroll found in Cave 1 (1QIsa"), _c('sup', [_vm._v("a")]), _vm._v("). The majority of Deuteronomy fragments turned up in Cave 4, a few coming from Caves 1, 2, and elsewhere. Deuteronomy is represented in nine "), _c('em', [_vm._v("mezuzot")])]), _c('a', {
    attrs: {
      "href": "#/008_Introduction1#f-1",
      "id": "f1"
    }
  }, [_vm._v("*")]), _vm._v(" and thirty-three phylacteries,"), _c('a', {
    attrs: {
      "href": "#/008_Introduction1#f-2",
      "id": "f2"
    }
  }, [_vm._v("†")]), _vm._v(" which contain verses from the Decalogue and the "), _c('em', [_vm._v("Shema")]), _vm._v(" in 5:1–6:9, portions of 10:12–11:21, and in one case verses from the Song of Moses (Deuteronomy 32).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A couple of Qumran readings in the Song of Moses are of particular importance. In 4QDeut"), _c('sup', [_vm._v("j")]), _vm._v(" the reading "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("בני אלוהים")]), _vm._v(" (“sons of God”) occurs in 32:8 (Ulrich, Cross et al. 1995, 90), where MT and the Versions all have "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("בְּנֵי יִשְׂרָאֵל")]), _vm._v(" (“sons of Israel”). The LXX supports the Qumran text with ἀγγέλων θεο"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ῦ")]), _vm._v(") (“angels of God”). Also, a 4QDeut"), _c('sup', [_vm._v("q")]), _vm._v(" reading of 32:43 expands the two poetic lines of MT into three (Ulrich, Cross et al. 1995, 141). The LXX expands the verse to four poetic lines (see Note for 32:43). For a discussion of the Deuteronomy texts found in the Qumran caves and in the Judean Desert, see J. Duncan, “Deuteronomy, Book of” in "), _c('em', [_vm._v("EDSS")]), _vm._v(" 198–202.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Qumran "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" (11QT) expounds large sections of Deuteronomy (Yadin 1977; 1983, vols. 1–2; Crawford 2005b, 137–40), although it harmonizes the Deuteronomic texts with texts from Exodus, Leviticus, and Numbers to create a unified whole. The Deuteronomic texts are largely those from chapters 12–26, 28, which can be found in 11QT 43, 48, 51–57, and 59–66. In 11QT two texts from chapter 7 are inserted into the covenant renewal passage of Exod 34:10–16. Occasionally the "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" makes a substantive change, e.g., in "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Deut 21:22, where the biblical text reads: “and he is put to death and you hang him upon a tree,” it changes the word order to read: “you shall hang him on a tree, and he shall die” (11QT 64:8; Yadin 1983, 1:81; 2:289–90). Here the author makes the cause of death the hanging, which is not what the biblical passage intends. The "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" also changes grammar so that God, not Moses, is speaking (Yadin 1983, 1:71–73), which brings the Deuteronomic discourse into line with the discourse of Exodus. This has the law given directly by God, not handed down through Moses. Other Qumran documents indicating the importance of Deuteronomy in the Dead Sea Community include 4Q473 on “The Two Ways” (Brooke et al. 1996, 292–94); 4QMMT (Qimron and Strugnell 1994, 58–61; Fraade 2003, 150–51); and 1Q22 on the “Words of Moses” (Barthélemy and Milik 1955, 91–96).")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-4"
    }
  }, [_vm._v("PARAGRAPH DIVISIONS")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The MT, Samaritan Pentateuch, Qumran biblical fragments, and Qumran "), _c('em', [_vm._v("Temple Scroll")]), _vm._v(" all contain paragraph divisions. There are two types: the closed section, marked by a "), _c('em', [_vm._v("setumah")]), _vm._v(" ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ס")]), _vm._v("), and the open section, marked by a "), _c('em', [_vm._v("petu"), _c('span', {
    staticClass: "f1"
  }, [_vm._v("ḥ")]), _vm._v("ah")]), _vm._v(" ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("פ")]), _vm._v("). The texts simply have blank spaces at the beginning, middle, and end of lines, or between lines; the sigla "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ס")]), _vm._v(" and "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("פ")]), _vm._v(" are put in later, their first known appearance being in an edition of Isaiah and Jeremiah published at Lisbon in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 1492 (Ginsburg 1885, 3:xvi). Before the Dead Sea Scrolls were found, these section markings were thought to be later. The Mishnah (ca. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 200) mentions paragraphs in the Pentateuch and the Prophets, but the distinction between open and closed sections is first made in the Talmud (cf. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 500). Jerome’s Hebrew text shows the subdivisions plainly (Pfeiffer 1948, 81). Now that sections have turned up in Qumran texts, we realize that they are even more ancient, and that they can be very useful in delimiting discourse units.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-5"
    }
  }, [_vm._v("DEUTERONOMY PAPYRI")])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Some important early papyri contain portions of Deuteronomy. The Nash Papyrus (S. A. Cooke 1903), a liturgical text written in Hebrew, comes from Egypt, perhaps Fayum, and is dated by Albright (1937, 149) to the second half of the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.")]), _vm._v(" It contains the entire Decalogue (Exod 20:2–17; Deut 5:6–21) and the Shema (Deut 6:4–5). The text of the Decalogue appears to combine Exodus and Deuteronomy. The Roberts Papyrus (P. Ryl. Gk. 458; Roberts 1936), a Greek text also from Egypt and dated to the end of the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C.")]), _vm._v(", a mere one hundred years after the Torah was translated into Greek in Alexandria ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("(LXX), contains four fragmented columns of a Deuteronomy scroll (23:25–24:3; 25:1–3; 26:12, 17–19; 28:31–33). These were used along with a fragment of the "), _c('em', [_vm._v("Iliad")]), _vm._v(" to wrap a mummy.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("From the early second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" comes the Chester Beatty Biblical Papyri (Kenyon 1935), another important collection of twelve Greek manuscripts of the Bible emanating from Egypt, probably having been discovered in the ruins of an early Christian church or monastery in the neighborhood of Fayum. Papyrus VI is a codex of what originally were the complete books of Numbers and Deuteronomy (216 pages, or 108 leaves). A large portion of Deuteronomy has survived (1:20–33, 35–46; 2:1–3:21; 3:23–4:49; 5:1–7:10; 7:12–13, 15–20; 9:26, 29; 10:1–2, 5–7, 11–12, 19–21; 11:12–13, 17–18, 31–32; 12:2–4, 15–17; 18:22; 19:1, 4–6, 10–11, 13–14, 16; 27:6–8, 13–15; 28:1–4, 7–10, 12–13, 16–20, 22–25, 27–30, 32–35, 38–41, 43–68; 29:1–18, 20–21, 23–27; 30:1, 4–6, 10–11, 12–13, 16–17, 19–20; 31:3–4, 8–16, 18, 21–23, 26–29; 32:3–5, 10–13, 17–19, 24–25, 27–29; 33:24–26; 34:11–12). This manuscript presents few textual problems and contains no notable new readings (Roberts 1936, 41).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-6"
    }
  }, [_vm._v("DATE, COMPOSITION, AND AUTHORSHIP")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-20",
    attrs: {
      "id": "sec2-1"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OSIANIC")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EFORM")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Modern research in Deuteronomy—indeed in the entire Pentateuch—builds on the thesis of W. M. L. de Wette (1830; 1843, 2:150–54), published originally in 1805, that Deuteronomy was the lawbook found in the temple during the reign of King Josiah (2 Kgs 22:8). Some early church fathers, viz., Athanasius, Chrysostom, Jerome, and Theodoret, also made the identification (Nestle 1902), but de Wette went farther in arguing that Deuteronomy had been written shortly before it was found. This appropriated earlier critical views rejecting Mosaic authorship and put Deuteronomy’s composition in the seventh century. De Wette also compared Deuteronomy with Joshua to 2 Kings and found here a peculiar style and content, now called “Deuteronomic.” His thesis was widely accepted, becoming the linchpin in modern critical theory of the Pentateuch (Rowley 1963b, 161; Eissfeldt 1965, 173).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("By the time of Wellhausen, in 1878, Deuteronomy (Source D) had become one of the four pillars of pentateuchal theory, and it was agreed that D preceded Priestly legislation (Source P) in Numbers, Leviticus, and portions of Exodus, rather than vice versa (Wellhausen 1957). Since D was found exclusively in Deuteronomy, or nearly so, it did not have to be disentangled from other source documents. Wellhausen’s views were presented convincingly to Anglo-American scholars by S. R. Driver who, in the "), _c('em', [_vm._v("Introduction")]), _vm._v(" to his ICC "), _c('em', [_vm._v("Deuteronomy")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("(lxxvii–xciv), compiled extensive lists of vocabulary and phraseology characterizing the D source and, in the words of one scholar, “brought down to earth what had hitherto dwelt in the clouds.”")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("A seventh-century date for Deuteronomy is now widely accepted, although some would push back the composition to the reigns of Manasseh or Hezekiah, arguing that portions of the book betray a northern provenance and may date from before or just after the fall of the northern kingdom (722). A postexilic date for P and its dependence upon D have more recently been challenged by Yehezkel Kaufmann (Greenberg 1950; Weinfeld 1972, 179–80; 2004, 3–74; "), _c('em', [_vm._v("EncJud")]), _vm._v(" 13:240), and there is a growing consensus—particularly among Jewish scholars—that P is older, preexilic in any case, and perhaps contemporary with D (Freedman; Weinfeld 2004, xii). Weinfeld sees the two documents as representing two theological schools: P characterized by a theocentric approach; D characterized by an anthropocentric approach (Weinfeld 1972, 179–89; 2004, 77–94).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Josianic reform, as reported in 2 Kings 22–23, appears to owe much to Deuteronomy. The purge carried out by the young king in Jerusalem, Judah, and sites to the north (2 Kgs 23:4–20) is said to have taken place immediately following the finding of the scroll in the temple, and specific acts of the purge—the temple cleansing and destruction of vessels and other cult objects dedicated to foreign deities; the destruction of high places with their altars, pillars, and Asherim; the deposition of idolatrous priests in Jerusalem and slaying of idolatrous priests in the northern cities; the tearing down of chambers in the temple belonging to cult prostitutes; and the elimination of various other elements of foreign worship—all seem to correlate with the prohibitions in Deut 5–26, 28—not only in content, but in vocabulary and phraseology (Driver 1895, xlv; Paton 1928, 325–26; Weiser 1961, 127–28; Nicholson 1967, 3).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("According to 2 Kings 23, a covenant renewal ceremony preceded the purge, and a grand celebration of Passover took place afterwards, in Jerusalem, now the one and only legitimate sanctuary for Yahweh worship. Covenant renewal and centralization of worship are at the heart of Deuteronomy, which mandates that worship occur only at “the place that Yahweh your God will choose (out of/in all your tribes) to put his name there,” or descriptions of the like (12:5, 11, 14, 18, 21, 26). Finally, since Huldah’s oracle (2 Kgs 22:16–17) declares certain judgment upon Judah for covenant violation, some scholars (G. A. Smith 1918, 194; G. E. Wright 1953, 320; H. L. Ginsberg 1982, 39) have argued that the curses of Deuteronomy 28 must be included on the temple scroll.")])]), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" Q"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UEST FOR")]), _vm._v(" "), _c('em', [_vm._v("U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RDEUTERONOMIUM")])])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("In the years following the placement of Deuteronomy in the context of the Josianic reform, a quest for "), _c('em', [_vm._v("Urdeuteronomium")]), _vm._v(" (“proto-Deuteronomy”) began, since it was thought that the scroll of 622 could not possibly contain all the material now found in our present book of Deuteronomy. The quest began with Wellhausen (1889, 191–95), who believed that the newly found scroll contained only the core legislation in chapters 12–26. This core, in his view, appeared in two editions, each of which contained its own introduction: chapters 1–4 and chapters 5–11 (Wellhausen 1957, 369). DeWette had argued earlier (1843, 2:131) that 4:44 began a new collection of Mosaic law containing a sermonic admonition similar to the first admonition in 1:1–4:40. This view of two editions was adopted by J. Estlin Carpenter (1883, 254–55) and numerous other scholars.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("S. R. Driver (1895, lxvi–lxxii, 135), however, pointed out soon after that so far as language and style were concerned, there was nothing in chapters 5–11 to suggest a different author from chapters 12–26, and he concluded that chapters 5–26 were the work of a single author, a view that gained broad acceptance (G. E. Wright 1953, 318; von Rad 1962a, 832). Driver also saw no reason to assign chapters 1–3(4) to a different hand than chapters 5–26 (Driver 1895, lxxii; 1913, 94; cf. Albright 1957b, 319), though he did concede the view of earlier scholars that, for some reason, the book contained two superscriptions: 1:1–5 and 4:44–49. He said (p. 79) that the summary in 4:44–49 appeared to be superfluous after 1:1–5, introducing as it does not simply chapters 1–4, but the Deuteronomic discourses generally (v. 5: “to make plain this law”). Despite this difficulty, numerous scholars have followed Driver in viewing 1:1–5 and 4:44–49 as double superscriptions surviving in the present book (G. E. Wright 1953, 314; Nicholson 1967, 18; Fohrer 1968, 171; Lohfink 1968, 7; Weinfeld, 233–34; 1972, 69), a point to which we will return shortly.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A solution to this puzzlement of two apparent introductions was offered by Martin Noth in his study of the Deuteronomic History, published in 1943 (Noth 1981). Noth believed Deuteronomy was intended as an introduction to the entire Deuteronomic History (Deuteronomy to 2 Kings) and was the work of a single author. In his view, the Deuteronomic History could not begin with Creation, since he found no signs of Deuteronomic editing in Genesis to Numbers. But he did see a linkage of Deut 31:1–13 and 14 with Joshua 1. The Introduction to this great work must therefore have been Deuteronomy 1–3(4) (Noth 1981, 12–14). Viewed in this manner, the chapters did not introduce the Deuteronomic law, as Wellhausen and Driver imagined, but rather the larger history beginning with the conquest of Canaan and ending with the collapse of the Israelite nation.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Noth believed the Deuteronomic Historian took over the Deuteronomic ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("law consisting of Deut 4:44–30:20, which meant he was still taking 4:44–49 to be an introduction (p. 16). Since the last event recorded in 2 Kings is to be dated ca. 562, the writing of the Deuteronomic History was put shortly after. This thesis of Noth had wide appeal, although many scholars continued to believe that much of the Deuteronomic History was written before the fall of Jerusalem, some arguing that the work went through two editions (G. E. Wright 1953, 317; Freedman 1962, 716; Cross 1968; R. D. Nelson 1981). Freedman said the First Edition could be seen reaching a climax in 2 Kings 22–23, which reports the Josianic reform, and that “what follows is a melancholy epilogue.” Lohfink (1976, 231), too, thinks 2 Kings 22–23 contains material probably composed in Josiah’s lifetime. If this be the case, then Deuteronomy 1–4 as an introduction to the First Edition of the Deuteronomic History could be preexilic (Albright 1957b, 315). Fohrer (1968, 177) believes chapters 1–3 cannot be removed from the rest of the book and made the beginning of a Deuteronomic historical work, and agrees with Driver that these chapters are better taken as introducing the Deuteronomic law code.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Noth’s theory underwent further revision in the work of David Noel Freedman (1962, 716–18), who saw continuity between the end of Numbers and the beginning of Deuteronomy (he calls Deuteronomy 1–4 a “bridge” to what has gone before). Freedman believed therefore that the document completed ca. 560 was not the Deuteronomistic History, but rather a work he calls the “Primary History,” viz., Genesis to 2 Kings. Albright (1957b, 345) had earlier expressed the view that the Pentateuch existed in substantially its present form before 522. Only later was the Pentateuch separated out from the Primary History, according to Freedman, occasioned by an interest of the exilic community in the person of Moses and Israel’s experience in the wilderness. A linking between Numbers and Deuteronomy was seen also by Eissfeldt (1965, 157), who said that Deuteronomy 31–34 must be a direct continuation of Numbers 27, in that here Joshua’s appointment as Moses’ successor is brought to conclusion; also, in chapter 34 of Deuteronomy the last words and the death of Moses are reported.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Other source-critical studies were part of the quest for an "), _c('em', [_vm._v("Urdeuteronomium")]), _vm._v(". Staerk (1894, 76–93) and Steuernagel (1894), for example, attempted to show that the sudden and frequent changes between second singular and second plural forms of the verb in the speeches of Moses (the so-called "), _c('em', [_vm._v("Numeruswechsel")]), _vm._v(") were an indication of sources. But these theses failed to gain acceptance (von Rad 1962a, 832; Lohfink 1963a, 240; Fohrer 1968, 171; Hillers 1964a, 32–33), even along lines later proposed by Minette de Tillesse (1962). Lohfink considers the change to be a stylistic device, which it probably is (Begg 1994). G. Ernest Wright (p. 362) says: “Hebrew writers have the disconcerting habit of completely disregarding consistency in the use of pronouns (cf. e.g., 6:4 with 6:5; 6:13 with 6:14; 6:16–17 with 6:18–19),” and he discounts attempts to find different ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("sources in the singular and plural use of pronouns. I take the shift to be simply another facet of the celebrated Deuteronomic rhetoric: the singular “you” perhaps addressing the people as a whole, and the plural “you” addressing each person individually and emphatically (= “each and every one of you”). Shalom Paul (1991, 150) sees the shift from plural to singular in Amos 4:12 to be just the reverse, saying that with the singular in 4:12 “the impending chastisement is now addressed individually to each member of the nation.” Tigay (1996, 62) says the same with regard to Deueronomy: the singular emphasizes the responsibility of each individual, and the plural is used to emphasize Israel’s collective responsibility. Milgrom took this same position in responding to a paper of mine read at the Albright Institute in Jerusalem on 3 February 2005. Either way, we have support for the idea that “individual responsibility” does indeed exist in Deuteronomy and the Deuteronomic History (Albright 1957b, 326). Even Weinfeld (1992b, 174), who thinks the exchange may indicate different layers in the text, concludes by saying: “In general the interchange reflects stylistic variations introduced by the same author.” Sonsino (1980, 198), too, having compared the Deuteronomic discourse with the ANE treaties, treaty curses, and royal inscriptions, remarks:")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("These extra-biblical examples show that the particular grammatical inconsistencies noted in the biblical texts are really part of the normal literary style of the ancient Near East and need not be explained by recourse to a theory of editorial reworking.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("No consensus has therefore emerged on what portion of the present book may confidently be assigned to "), _c('em', [_vm._v("Urdeuteronomium")]), _vm._v(" (Eissfeldt 1965, 173–76; Fohrer 1968, 169–72). There is simply general agreement that the 622 lawbook contained at most chapters 5–26, 28 (Freedman 1962, 715; Nicholson 1967, 22; Weinfeld, "), _c('em', [_vm._v("EncJud")]), _vm._v(", 5:1574), and it may well have contained less. Von Rad (1962a, 832) stated more than forty-five years ago: “Obviously the zeal for literary analysis has flagged for a long time.” The quest for "), _c('em', [_vm._v("Urdeuteronomium")]), _vm._v(" had reached a dead end, with nothing more known about the contents of "), _c('em', [_vm._v("Urdeuteronomium")]), _vm._v(" than was purportedly known at the turn of the century (Lundbom 1976, 294).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-3"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORTHERN")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROVENANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Another search into Deuteronomy’s prehistory was carried out during the last century, viz., an inquiry into the book’s provenance. It began largely with Adam Welch, who argued that the book of Deuteronomy came originally from North Israel (Welch 1924, 184–85, 190–91). Welch said the author of 27:4")])]), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("evidently regarded the sanctuary at Ebal as being the first which was erected in Palestine, and as owing its authority to the direct command of the great lawgiver. Again we have a significant hint as to the provenance of the Deuteronomic code, for we are carried to Northern Israel and to one of its leading sanctuaries.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("Welch found Deuteronomy’s mandate for a single sanctuary only in chapter 12, although he argued that 12:1–7 was a later addition (1932, 205). His view of chapter 12 did not win the day, nor also his view that Deuteronomy was composed in the tenth century, but his idea about Deuteronomy having a northern provenance had considerable impact (Albright 1957b, 315; G. E. Wright, 326; von Rad 1962a, 836; 1966a, 94; Nicholson 1967, 58–82; Fohrer 1968, 175).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The view of Alt (1953b) that Deuteronomy was a restoration program in North Israel after the fall of Samaria in 722 has little to recommend it, and is best laid to rest (Nicholson 1967, 80–81). The two passages testing for inauthentic prophets, in chapters 13 and 18, seem to me to be a legacy of Northern Israel’s experience with prophets during the reign of Ahab (Lundbom 1996, 309–12). Nicholson (1967, 69) sees “vital contacts between Deuteronomy and the teaching of the prophetic party in northern Israel,” saying that a good case can be made for Deuteronomy owing its origin to prophetic circles in northern Israel (p. 79).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Others have argued that Deuteronomy originated largely in Judah (Lohfink; Weinfeld), perhaps even before the time of Hezekiah. The passage on judges in 16:18–20 points to the reign of Jehoshaphat (873–849), who carried out a judicial reform in Judah (2 Chr 19:4–11) and is reported by the Chronicler as having sent out princes and Levites to teach people the law (2 Chr 17:7–9). Ahab reigned in the north and Jehoshaphat in the south during the mid-ninth century, with both the Deuteronomic Historian and the Chronicler reporting good relations between the two kings (1 Kgs 22:45[44]; 2 Chr 18:1–3). Ahab is not likely to have sponsored an early Deuteronomic program, but Jehoshaphat could have (Albright 1957b, 320).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If the book of Deuteronomy or portions of it did originate in North Israel, that book was most likely brought to Jerusalem after the fall of Samaria in 722. Fohrer (1968, 175) thinks it was deposited in the temple in the time of Hezekiah. To what extent it could have played a role in Hezekiah’s reform before coming to light in the time of Josiah is the question to which we now turn.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-4"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EZEKIAH")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EFORM")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("De Wette’s view that Deuteronomy was written shortly before its discovery in the temple has been challenged over the years, by many rejected outright, ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("largely because the time span between the young Josiah’s accession in 640 and the discovery of the lawbook in 622 is too brief. It is usually assumed that the newly found lawbook had been lost for some time (Driver 1895, liv–lv), for which reason many scholars have pushed back the date of Deuteronomy’s composition to the reigns of Manasseh (687–642) or Hezekiah (715–687). Manasseh’s reign was nearly a half-century of idolatrous worship, yet some argue that during this time a reform document could have been written for the future, if and when an opportunity came for its use (Nicholson 1967, 101–2). Still, it is a stretch to imagine a vibrant document like Deuteronomy being written during the reign of Manasseh. Pfeiffer (1948, 180) says: “During the reign of Manasseh D[euteronomy] would have been consigned to the flames, like Jeremiah’s book later on (Jer. 36:23).”")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("A reform document such as Deuteronomy is more likely to have emanated from a reform in progress (like documents of the Reformation, or more recently Vatican II), favoring the reign of Hezekiah over the reign of Manasseh. In the Bible, a reform by Hezekiah is reported briefly in 2 Kgs 18:4, 22[= Isa 36:7], where it says that Hezekiah removed high places, altars, and other objectionable cult symbols in a move to purify Yahweh worship and centralize it in Jerusalem. In 2 Chronicles 29–31 this reform gets extended coverage. The Chronicler states that the good king began in his first year to make repairs in the temple (2 Chr 29:3), concluding his reform and other faithful acts before Sennacherib invaded Judah and encamped against its fortified cities (2 Chr 32:1).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Wellhausen (1957, 25) did not believe such a reform ever took place. He doubted the report in 2 Kings and dismissed out of hand the account of the Chronicler who, in his view, was not a credible historical source. More recently Na‘aman (1995) and Fried (2002) have challenged the results of archaeological studies pointing to a reform by Hezekiah, stating that the research does not support a reform. Besides being dismissive of the biblical accounts, they both misconstrue and outrun the archaeological evidence they cite and base too much on “arguments from silence.”")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("The Deuteronomic Historian and the Chronicler agree that Hezekiah carried out reforming activities at the beginning of his reign. There are, to be sure, chronological problems associated with Hezekiah’s accession and uncertainty too about the campaign(s) of Sennacherib against Judah and Jerusalem; nevertheless, a window of opportunity for carrying out a reform is arguable between 712 and 701 (Rainey 1994, 333 says between 715 and 701). Many scholars have accepted the biblical testimony that Hezekiah did carry out a reform, one that did away with objectionable objects of worship and aimed at creating a central sanctuary in Jerusalem. This reform was short-lived (Nicholson 1967, 99: between 705 and 701), as many reforms are, but not so short-lived that Deuteronomy ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("could not have been written while it was in progress, or else soon after. Freedman (1987d, 20–26) argued that the books of the eighth-century prophets, Amos, Hosea, Isaiah, and Micah, were assembled during the reign of Hezekiah to mark the destruction of the northern kingdom by the Assyrians in 722, the reason being that Israel failed to repent of its rebellion against Yahweh and gross violation of covenant demands, also because of Judah’s deliverance from the Assyrians in 701, at which time Hezekiah repented of his rebellion and violation of covenant demands (cf. Jer 26:19). Freedman says: “Only a king of such stature and ethical sensitivity, as Hezekiah is described to be, could and would have encouraged such a work” (Freedman 1987d, 24).")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Most current scholars state their views on the composition of Deuteronomy in general terms, usually content to say that the book was written in the seventh century, or between the reigns of Hezekiah and Josiah. It is difficult to be more precise when we do not know more. For a fuller discussion of Hezekiah’s reform and issues related to the reform, see Excursus 1.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-5"
    }
  }, [_vm._v("A N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" Q"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UEST FOR")]), _vm._v(" "), _c('em', [_vm._v("U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RDEUTERONOMIUM")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Since Wellhausen, a change has taken place in appraising the work of the Chronicler. Wellhausen believed the Chronicler was late and unreliable. Welch (1939) viewed the Chronicler more positively, but his assessment has been largely ignored. The change occurred with Albright (1957b, 273; 1963, 76–77), whose views survived in the work of his students: John Bright (1981, 229), also Frank M. Cross and David Noel Freedman (1953). Cross and Freedman pointed out that so far as the Josianic reform was concerned, the Chronicler’s scheme of events correlated better with the extrabiblical records documenting Assyria’s decline. Nicholson (1967, 11–12) in his overview therefore concludes that the Chronicler’s report of the Josianic reform is basically reliable, which is what Albright concluded about the Chronicler’s report of the reform of Hezekiah.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In an earlier work (Lundbom 1976), I proposed that the Chronicler’s account of the Josianic reform be given precedence over the account of the Deuteronomic Historian (DH), which would mean putting the main purge of pagan worship in 628, rather than 622, and seeing the legal portions of Deuteronomy as being the moving force behind the reform activity in that year. Deuteronomy 5–26, 28—or better, Deuteronomy 1–28—was not the lost lawbook. The lawbook newly found in 622 was the much briefer Song of Moses in Deuteronomy 32.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Two lines of evidence point to one and the same conclusion. The first is this: Two stanzas of the Song of Moses (Deut 32:15–22) compare closely in content to a portion of Huldah’s oracle in 2 Kgs 22:16–20. Huldah was the prophetess ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("to whom Hilkiah went with the lawbook in order to obtain a divine oracle. She heard the scroll read, or else read it herself, and responded with a two-part oracle, the first part directed to the nation (vv. 16–17) and the second part to the king (vv. 18–20). It is the first part that draws upon the Song of Moses. The relevant texts are the following:")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "BodySb"
  }, [_c('strong', [_vm._v("Deut 32:15–22")])]), _vm._v(" "), _c('table', {
    staticClass: "tab"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וַיִּשְׁמַן יְשֻׁרוּן וַיִּבְעָט שָׁמַנְתָּ עָבִיתָ כָּשִׂיתָ")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("יַקְנִאֻהוּ בְּזָרִים בְּתוֹעֵבֹת יַכְעִיסֻהוּ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("15")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וַיִּטֹּשׁ אֱלוֹהַ עָשָׂהוּ וַיְנַבֵּל צוּר יְשֻׁעָתוֹ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("16")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("יִזְבְּחוּ לַשֵּׁדִים לֹא אֱלֹהַ אֱלֹהִים לֹא יְדָעוּם")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("חֲדָשִׁים מִקָּרֹב בָּאוּ לֹא שְׂעָרוּם אֲבֹתֵיכֶם")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("צוּר יְלָדְךָ תֶּשִׁי וַתִּשְׁכַּח אֵל מְחֹלְלֶךָ")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("18")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he-t"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וַיַּרְא יְהוָה וַיִּנְאָץ מִכַּעַס בָּנָיו וּבְנֹתָיו")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("19")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וַיֹּאמֶר אַסְתִּירָה פָנַי מֵהֶם אֶרְאֶה מָה אַחֲרִיתָם")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כִּי דוֹר תַּהְפֻּכֹת הֵמָּה בָּנִים לֹא־אֵמֻן בָּם")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("20")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("הֵם קִנְאוּנִי בְלֹא־אֵל כִּעֲסוּנִי בְּהַבְלֵיהֶם")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וַאֲנִי אַקְנִיאֵם בְּלֹא־עָם בְּגוֹי נָבָל אַכְעִיסֵם")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("21")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כִּי־אֵשׁ קָדְחָה בְאַפִּי וַתִּיקַד עַד־שְׁאוֹל תַּחְתִּית")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וַתֹּאכַל אֶרֶץ וִיבֻלָהּ וַתְּלַהֵט מוֹסְדֵי הָרִים")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("22")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_c('strong', [_vm._v("2 Kgs 22:16–17")])]), _vm._v(" "), _c('table', {
    staticClass: "tab"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כֹּה אָמַר יְהוָה")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("הִנְנִי מֵבִיא רָעָה אֶל־הַמָּקוֹם הַזֶּה וְעַל־יֹשְׁבָיו")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֵת כָּל־דִּבְרֵי הַסֵּפֶר אֲשֶׁר קָרָא מֶלֶךְ יְהוּדָה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("16")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("תַּחַת אֲשֶׁר עֲזָבוּנִי וַיְקַטְּרוּ לֵאלֹהִים אֲחֵרִים")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("לְמַעַן הַכְעִיסֵנִי בְּכֹל מַעֲשֵׂה יְדֵיהֶם")])]), _vm._v(" "), _c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וְנִצְּתָה חֲמָתִי בַּמָּקוֹם הַזֶּה וְלֹא תִכְבֶּה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("17")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_c('strong', [_vm._v("Deut 32:15–22")])]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("15")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerseSb"
  }, [_vm._v("Yes, Jeshurun got fat and kicked;")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("you got fat, you grew thick, you became gorged.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse1"
  }, [_c('em', [_vm._v("Then he abandoned the God")]), _vm._v(" who made him,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("and took to be foolish the Rock of his salvation.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_vm._v("They made him jealous with strangers,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("with abominations "), _c('em', [_vm._v("they provoked him")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_vm._v("They "), _c('em', [_vm._v("sacrificed")]), _vm._v(" to demons, "), _c('em', [_vm._v("no gods")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("gods they had not known.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse1"
  }, [_vm._v("New ones recently come in,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("your fathers were not awed by them.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("18")])])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_c('em', [_vm._v("The Rock")]), _vm._v(" that begot you, "), _c('em', [_vm._v("you neglected")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_c('em', [_vm._v("and you forgot the God")]), _vm._v(" who bore you in travail.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("19")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerseSb"
  }, [_vm._v("So Yahweh saw and spurned")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("because of "), _c('em', [_vm._v("the provocation")]), _vm._v(" of his sons and daughters.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("20")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_vm._v("And he said, I will hide my face from them,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("I will see what their end will be.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse1"
  }, [_vm._v("For a generation of perversities they are,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("children in whom is no faithfulness.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_vm._v("They, they have made me jealous with a no-god,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_c('em', [_vm._v("they provoked me with their nothings")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Verse1"
  }, [_vm._v("So I, I will make them jealous with a no-people,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("with a foolish nation I will provoke them.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("22")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_vm._v("For "), _c('em', [_vm._v("a fire is kindled in my anger")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_c('em', [_vm._v("and it will burn to the depths of Sheol")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Verse1"
  }, [_vm._v("Yes, it will consume the earth and its yield")]), _vm._v(" "), _c('p', {
    staticClass: "Verse2"
  }, [_vm._v("and set ablaze the mountains’ foundations.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_c('strong', [_vm._v("2 Kgs 22:16–17")])]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_vm._v("Thus says Yahweh:")]), _vm._v(" "), _c('p', {
    staticClass: "TVerse1"
  }, [_vm._v("Behold I will bring evil upon this place and upon its inhabitants—all the things of the book which the king of Judah has read.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "BVerse1"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "TVerse"
  }, [_vm._v("Because "), _c('em', [_vm._v("they have forsaken me and have burned incense to othergods")]), _vm._v(", that "), _c('em', [_vm._v("they might provoke me with all the work of their hands. Therefore my wrath will be kindled against this place and it will not be quenched")]), _vm._v(".")])])])])]), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("One can immediately see that while the vocabularies of the two passages are somewhat different, the substance is the same. In both we note: (1) that Israel is indicted because she has "), _c('em', [_vm._v("forgotten")]), _vm._v(" Yahweh and "), _c('em', [_vm._v("provoked him by sacrificing to other gods;")]), _vm._v(" and (2) that Yahweh’s "), _c('em', [_vm._v("wrath")]), _vm._v(" is promised to "), _c('em', [_vm._v("burn")]), _vm._v(" in judgment like an "), _c('em', [_vm._v("unquenchable fire")]), _vm._v(". Huldah has restated the message of the Song in the current idiom, or else the DH has stylized her speech using the current idiom (so Driver 1895, xlv). The result, in either case, is the oracle as we now have it. Since this exact combination of ideas is not to be found elsewhere in the OT in the way it appears in these two passages, we may conclude that Huldah drew the substance of her indictment against Israel from the Song of Moses.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The second bit of evidence comes from a rhetorical structure in the prose frame to the Song. In Deut 31:24–30 and 32:44–46 a keyword chiasmus makes Moses’ “song” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("שִּׁירָה")]), _vm._v(") into a “law” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("תּוֹרָה")]), _vm._v("), with “words” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("דְּבָרִים")]), _vm._v("), a good Deuteronomic term, mediating in between:")]), _vm._v(" "), _c('table', {
    staticClass: "tab"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־דִּבְרֵי הַתּוֹרָה־הַזּאֹת")])])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("31:24")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he1"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֵת הַדְּבָרִים הָאֵלֶּה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he2"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־דִּבְרֵי הַשִּׁירָה הַזּאֹת")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("30")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he2-t"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־כָּל־דִּבְרֵי הַשִּׁירָה־הַזּאֹת")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("32:44")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he1"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־כָּל־הַדְּבָרִים הָאֵלֶּה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("45")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־כָּל־דִּבְרֵי הַתּוֹרָה הַזּאֹת")])])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("46")])])])])]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("31:24")])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "Verse"
  }, [_vm._v("the words of "), _c('em', [_vm._v("this law")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("28")])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "Verse1"
  }, [_c('em', [_vm._v("these words")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("30")])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "Verse2"
  }, [_vm._v("the words of "), _c('em', [_vm._v("this song")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("32:44")])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "Verse2-t"
  }, [_vm._v("all the words of "), _c('em', [_vm._v("this song")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("45")])]), _vm._v(" "), _c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "Verse1"
  }, [_vm._v("all "), _c('em', [_vm._v("these words")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("46")])]), _vm._v(" "), _c('td', {
    staticClass: "w90"
  }, [_c('p', {
    staticClass: "Verse"
  }, [_vm._v("all the words of "), _c('em', [_vm._v("this law")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("One final piece of evidence serves to connect the Song of Moses to the lawbook of 622. The expression, "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("סֵפֶר הַתּוֹרָה")]), _vm._v(" (“book of the law”), which in Deut 31:26 refers to the scroll on which the Song of Moses—not the entire Deuteronomic code—was written, occurs also in 2 Kgs 22:8, where it refers to the temple lawbook. The identification is thus complete: "), _c('em', [_vm._v("Deuteronomy 32 is the lawbook Hilkiah found in the temple in 622")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Some scholars (Kaufmann 1960, 175; Holladay 1966, 26; 2004, 73–74) have suggested that the Song of Moses be included in "), _c('em', [_vm._v("Urdeuteronomium")]), _vm._v(", but if added to a document containing 5–26, 28, or 1–28, we have a scroll rather large to have been read three times in one day. It is possible, but not likely. It is better, therefore, to take only the Song of Moses as the lawbook of 622. In my view, the Song is the core of the second supplement (chs. 31–34) to the First Edition, this supplement having been added after the Song’s discovery in the temple. This final expansion in our present book of Deuteronomy could have been completed in the latter years of Josiah, at the same time the First Edition of the Deuteronomic History was written.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("What then are we to make of the narrative in 2 Kings 22–23, which leads us to believe that all the reform activity came about because of the lawbook’s discovery in 622? The passage out of chronological order in the scheme of the DH appears to be 2 Kgs 23:4–20. The purge reported there took place six years earlier (2 Chr 34:3–7). My solution would be to take 2 Kgs 23:4–20, which describes the purge, as a separate account that the DH has incorporated into his narration of the Josianic reform. It speaks of the “book of the covenant” (2 Kgs 23:2–3, 21), which as Carpenter (1883, 277) noted years ago, was a title well-suited for the Deuteronomic Code, beginning as it does with the “covenant” of ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Horeb and ending with the “covenant” of Moab (5:2; 28:69 [29:1]). We can then proceed to discover another rhetorical structure for 2 Kgs 22:8–23:25, even if we remain unable to judge the DH’s knowledge or lack of knowledge about how the reform activity actually played out. It is reasonable to assume that he did know the actual sequence of events, simply choosing for whatever reason to schematize his reporting of them.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The DH intends to make the purge the center and climax of his narrative. We know it is the climax because of the space he gives it: seventeen verses compared to five by the Chronicler. But it is also the center, as we can see by observing a keyword chiasmus in the prose frame to the account. This is a structure similar to the one framing the Song of Moses in Deut 31:24–30 and 32:44–46:")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_c('strong', [_vm._v("2 Kings 22:8–23:25")])]), _vm._v(" "), _c('table', {
    staticClass: "tab"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("סֵפֶר הַתּוֹרָה מָצָאתִי בְּבֵית יהוה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("22:8")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־דִּבְרֵי סֵפֶר הַתּוֹרָה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "he1-t"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־כָּל־דִּבְרֵי סֵפֶר הַבְּרִית הַנִּמְצָא בְּבֵית יהוה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("23:2")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "he1"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־דִּבְרֵי הַבְּרִית הַזּאֹת הַכְּתֻכִים עַל־הַסֵּפֶר הַזֶּה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "he2-t"
  }, [_vm._v("Account of the Purge")])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("4–20")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "he1-t"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כַּכָּתוּב עַל סֵפֶר הַבְּרִית הַזֶּה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "he-t"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֶת־דִּבְרֵי הַתּוֹרָה הַכְּתֻבִים עַל־הַסֵּפֶר אֲשֶׁר מָצָא … בֵית יהוה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("24")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "he"
  }, [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כְּכֹל תּוֹרַת מֹשֶׁה")])])]), _vm._v(" "), _c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("25")])])])])]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("22:8")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "Verse"
  }, [_vm._v("I have found "), _c('em', [_vm._v("the book of the law")]), _vm._v(" in the house of Yahweh")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("11")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "Verse"
  }, [_vm._v("the words of "), _c('em', [_vm._v("the book of the law")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("23:2")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "Verse2Sb"
  }, [_vm._v("all the words of "), _c('em', [_vm._v("the book of the covenant")]), _vm._v(" that")]), _vm._v(" "), _c('p', {
    staticClass: "Verse3"
  }, [_vm._v("had been found in the house of Yahweh")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("3")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "Verse2"
  }, [_vm._v("the words of "), _c('em', [_vm._v("this covenant")]), _vm._v(" that were written in "), _c('em', [_vm._v("this book")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("4–20")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "Verse3Sb"
  }, [_vm._v("Account of the Purge")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("21")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "Verse2Sb"
  }, [_vm._v("as it is written in "), _c('em', [_vm._v("this book of the covenant")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num1"
  }, [_vm._v("24")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "VerseSb"
  }, [_vm._v("the words of "), _c('em', [_vm._v("the law")]), _vm._v(" that were written in "), _c('em', [_vm._v("the book")]), _vm._v(" that")]), _vm._v(" "), _c('p', {
    staticClass: "Verse1Sb"
  }, [_vm._v("[Hilkiah] … found in the house of Yahweh")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w15"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("25")])]), _vm._v(" "), _c('td', {
    staticClass: "w80"
  }, [_c('p', {
    staticClass: "Verse"
  }, [_vm._v("according to all "), _c('em', [_vm._v("the law of Moses")])])])])])])]), _c('p', {
    staticClass: "BodySb"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("The account in 2 Kgs 22:8–23:25 is a conflation at two points: (1) it combines the purge of 628 with whatever reform measures took place in 622, making ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("it appear that Josiah undertook a single purge of pagan worship centers after the lawbook was found; and (2) it combines a “(book of the) law” from Moses (22:3–20; 23:24–25) with a “book of the covenant” (23:1–3, 21–23), making it appear that a single temple scroll inspired Huldah’s oracle, formed the basis for Josiah’s covenant renewal ceremony, led to the purge of pagan worship centers, and guided the king to host the grandest Passover in Jerusalem since the days of the Judges. The “(book of the) law” was the Song of Moses (32); the “book of the covenant” was the First Edition of Deuteronomy (1–28). A conflation of the same sort occurred in Deuteronomy 31–34, where the Song of Moses was integrated into the First Edition of Deuteronomy and made a part of Moses’ ever-expanding collection of “torah” (Lundbom 1990).")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Some earlier scholars believed that 2 Kings 22–23 altered or schematized events in Josiah’s reign in order to create the impression that Deuteronomy was Josiah’s lawbook, but they did so to argue for an exilic or postexilic date of Deuteronomy (Nicholson 1967, 4–7). I agree that the events in 2 Kings 22–23 have been schematized to create the impression desired by the DH, but I do not think an exilic or postexilic date for the book is at all likely. As noted earlier, 2 Kings 22–23 is the climax to a First Edition of the Deuteronomic History, in my view a preexilic work.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-6"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" Q"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UESTION OF")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTHORSHIP")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("With critical theory concluding that Moses was not the author of Deuteronomy, nor of the Pentateuch as a whole, the question was then: “Who wrote Deuteronomy?” Carpenter (1883), Driver (1895, xxv–xxix), and others emphasized the prophetic character of Deuteronomy, Driver believing that the work, although legal in nature, nevertheless built on foundations laid by the prophets, mainly Hosea and Isaiah. He called Deuteronomy a “prophetic lawbook.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Along with Wellhausen and others of his time, Driver saw the prophets as moral giants in ancient Israel, individuals who “held up before the people high conceptions of life and duty.” Deuteronomy was the spiritual heir of Hosea, joining him in repudiating nature worship and acknowledging Yahweh as the true giver of earth’s bounty. Driver says Deuteronomy agreed with Hosea in giving prominence to the emotional side of religion—love, affection, and sympathy are all present, particularly love. This love is a moral love, limited when necessary by the demands of righteousness; thus idolatry and immorality cannot be tolerated or condoned by it.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Driver pointed to the monotheistic creed of Deuteronomy (4:35, 39; 6:4; 7:9; 10:17) as another development of prophetic teaching. Deuteronomy preaches and teaches monotheism more formally and explicitly than earlier ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("biblical books. The single sanctuary, in his view, was the corollary to the monotheistic idea. That worship at one Jerusalem altar developed later into a false religion of security (Jer 7:1–15) did not render invalid Deuteronomy’s view at an earlier stage.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("At the same time, Driver (1895, xxx) says that with priestly institutions the author of Deuteronomy has greater sympathy than with prophets generally. He evinces a warm regard for the priestly tribe; he guards its privileges (18:1–8), demands obedience for its decisions (24:8; cf. 17:10–12), and commends its members to Israelite benevolence (12:18–19; 14:27, 29, etc.). This author has no desire to see ceremonial observances current at the time abolished; sacrifice, though not emphasized, is taken for granted. Offerings on which Deuteronomy lays the greatest stress are those expressive of gratitude to God as Giver of all good things in the land (14:22–27; 15:19–23; 16:10, 15, 17; 26:10). Religious feasts are to be occasions of gladness before Yahweh and a display of generous hospitality towards the destitute (12:7, 12, 18; 14:26–27; 16:11, 14; 26:11). In Deuteronomy the tribe of Levi is confirmed in its possession of priestly rights, and it alone is to supply ministers for the sanctuary (Driver 1895, xxv).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The term “Levites” in Deuteronomy refers to all priests. The expression, "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כֹּהֲנִים הַלְוִיִּם")]), _vm._v(", “the priests, the Levites” (= the Levitical priests), appears in 17:9, 18; 18:1; 24:8; 27:9 and other literature earlier than Nehemiah, e.g., Josh 3:3; 8:33; Jer 33:18; Ezek 43:19; 44:15. It need not be taken, then, as an archaism by someone writing in the postexilic period. According to Levine (1993, 104–5, 449, 450), stratification of the tribe into two groups, priests and Levites, first occurs explicitly in Numbers (chs. 3–4, 8, 16–17). There is no reference to the subordination of Levites in Exodus. On the priests and Levites, see further G. E. Wright (1954) and Emerton (1962).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The question of authorship, therefore, took a different turn with von Rad (1953; 1962a, 835–37), who believed that although Deuteronomy reflected an ancient Shechemite cultic festival (11:26–32), the preachers behind its sermons were post-701 Levitical priests from the Judean countryside. Von Rad cites Neh 8:1–8, where the Levites instruct as Ezra reads people the law. The Chronicler, too, makes numerous references to the Levites as teaching priests (2 Chr 15:3; 17:7–9; 35:3). One notes that Deut 31:9 says the Deuteronomic code, after being written down by Moses, was put into the hands of the Levitical priests. In Deut 20:2–4, too, the (Levitical) priests have a prominent role in addressing people before Israel is to go to war. Von Rad’s views were accepted by G. E. Wright, Muilenburg (1959, 348–350), and others, with Wolff (1956) arguing that Deuteronomy owed its origin to Levites in northern Israel who had been excluded from sanctuaries at Bethel and Dan by Jeroboam I (1 Kgs 12:31–32). Hosea, in Wolff’s view, was linked to this circle of Levites.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Priestly authorship of Deuteronomy came under scrutiny with Weinfeld ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("(1967; 1972, 158–71; "), _c('em', [_vm._v("EncJud")]), _vm._v(" 5:1578–79), who argued that the authors of Deuteronomy were scribes. Weinfeld agreed that Deuteronomy contained material of northern provenance, but was not surviving oral torah from preaching Levites. What we have in Deuteronomy is rather a written document compiled by scribes of the Jerusalem court. Such a conclusion, he argues, is supported by wisdom elements in the book, e.g., the education of children and various humanistic laws, which have no counterpart in any other pentateuchal book (Weinfeld 1960a). Numerous parallels exist also between Proverbs and Deuteronomy, e.g., Deut 19:14 with Prov 22:28; Deut 23:17 [16] with Prov 30:10; and Deut 25:13–16 with Prov 20:10, 23. Citing ANE treaty parallels to Deuteronomy, Weinfeld argues that scribes must have authored Deuteronomy, since only they would have been familiar with the treaty structures.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Weinfeld makes his case for scribal authorship of Deuteronomy, but his case against priestly authorship falls short of being decisive. Besides the evidence that von Rad presents for priestly authorship are biblical texts putting the torah in the hands of priests (Jer 18:18; Ezek 7:26). Also, 2 Chr 34:13 tells us that “some of the Levites were scribes,” which indicates that Weinfeld may have overdrawn his separation of the two vocations. This reference in Chronicles is important, since it occurs in the context of the Josianic reform. In Nehemiah 8, Ezra is called both “Ezra the priest” and “Ezra the scribe” (Neh 8:1, 9). If these overlaps in terminology correspond to reality in preexilic times, which is not hard to imagine (Mowinckel 1955, 206; Muilenburg 1970a, 230–31), Weinfeld’s argument that Deuteronomy is authored by scribes, not Levites, loses much of its force. The authors of Deuteronomy could have been both Levites and scribes. Finally, a presence of wisdom elements in Deuteronomy is not a sure pointer to scribal authorship. Amos and Jeremiah are brim full of wisdom teaching, and both are prophets, not scribes. Priests, scribes, and prophets from the eighth to sixth century, all shared a common intellectual and rhetorical tradition, fully capable of producing the discourse and teaching of Deuteronomy.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-7"
    }
  }, [_vm._v("ANCIENT NEAR EASTERN TREATIES")])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("By the mid-1950s the focus of Deuteronomy studies had shifted to the Hittite vassal treaties (1450–1200) unearthed at Boghazköy, published two decades earlier. George Mendenhall, in an important study (1955), pointed out the formal similarities between these treaties concluded between suzerains and their vassals, and the biblical covenants. Dennis McCarthy (1963, 109–40) went on to make it even more clear that the covenant form in Deuteronomy was the real beneficiary of the new comparison. Hittite treaties typically contained six elements: (1) a preamble, introducing the speaker (cf. Deut 1:1–5); (2) a historical ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("prologue (cf. chs. 1–4); (3) the stipulations (cf. chs. 5; 12–26); (4) provisions for depositing the document in the temple and a periodic reading (31:9–13, 26); (5) a list of the gods as witnesses (no parallel in Deuteronomy); and (6) blessings and curses (cf. chs. 27–28).")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In 1958 D. J. Wiseman published the Vassal Treaties of Esarhaddon, which were shown to have striking parallels to the maledictions in Deuteronomy 28. Subsequent studies have therefore focused on these treaties rather than those of the Hittites (D. J. McCarthy 1963, 68–79; Weinfeld 1991, 6–9; 1972, 59–157; 1976a; 1992b, 169–171), one reason being that they date from the same time as Deuteronomy, the seventh century. After examining these treaties, Weinfeld judged Deuteronomy to be a “loyalty oath” imposed by a suzerain (Yahweh) on his vassal (Israel) prior to a leadership change (Moses to Joshua). Similarities between the two were seen to extend even into the language, e.g., the terms for loyalty in both were “to go after” (= to follow), “to fear,” and “to hearken to the voice of”; and in both the vassal was commanded “to love” the suzerain “with all the heart and all the soul” (cf. Deut 6:5). On the use of the term “love” in the ANE treaties, see Moran 1963b. It is now generally accepted that these international treaties—both Hittite and Assyrian—influenced the form of the biblical covenants, particularly Deuteronomy (Weinfeld 1991, 9). Phillips (1983, 2) argues that the treaty form entered Israelite theology only after the fall of the northern kingdom, which would bring it into the time when Deuteronomy was written.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-8"
    }
  }, [_vm._v("ANCIENT HEBREW RHETORIC")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-20",
    attrs: {
      "id": "sec2-7"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HETORICAL")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROSE")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Since the beginning of pentateuchal criticism it has been recognized that Deuteronomy has a distinctive rhetorical style, characterized by stereotyped vocabulary and phraseology (Driver 1895, lxxvii–xci; 1913, 99–102; Weinfeld 1972, 320–65). Its prose teems with "), _c('em', [_vm._v("accumulatio")]), _vm._v(", i.e., nouns heaped up in twos, threes, and fours, and longer phrases balanced rhythmically in parallelism, also "), _c('em', [_vm._v("asyndeton")]), _vm._v(". This prose occurs also in the Deuteronomic History, particularly Kings, and in the book of Jeremiah (Lundbom 1999, 126–27). Deuteronomy, according to Driver, is fond of the emphatic form of "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("וּן")]), _vm._v(" in the second and third person plurals of the Imperfect, of "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("לֵבָב")]), _vm._v(" (47x) over "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("לֵב")]), _vm._v(", and of "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אָנֹכִי")]), _vm._v(" (56x) over "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("אֲנִי")]), _vm._v(". He believes these preferences are probably due to the writer’s sense of what harmonized best with the oratorical rhythm of his discourse. In Deuteronomy also are the frequent changes between second singular and second plural forms, about which we spoke earlier, and these must be reckoned as another rhetorical feature of Deuteronomic discourse.")])]), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REACHED")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")])])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("Gerhard von Rad, following the lead of August Klostermann (1893), said of Deuteronomy in comparison to the Book of the Covenant:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Deuteronomy is not divine law in codified form, but preaching about the commandments—at least, the commandments appear in a form where they are very much interspersed with parenesis. (von Rad 1953, 15; cf. 1966b, 30)")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The point was made also by Breit (1933) and by Driver in his "), _c('em', [_vm._v("Deuteronomy")]), _vm._v(" commentary. Driver saw Deuteronomy’s rhetorical discourse as aiming to inculcate religious and moral principles, being therefore of greater importance than the historical and legislative discourse in the book (Driver 1895, xix, lxxvii–lxxxviii). So far as Deuteronomy being a lawbook was concerned, Driver took it as a manual addressed to the people intended for popular use (Driver 1895, xxvi). H. Wheeler Robinson (1980, 3) said the exhortations in Deuteronomy could be compared with a sermon:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("It is a sermon so reported as to preserve the spiritual warmth of a Bernard preaching the Crusade, the flaming zeal of a Savonarola kindling the Florentine fire of vanities; whilst with this more passionate feeling against idolatry there is a noble humanitarianism, a consideration for the stranger and the helpless, an appeal to deep human sympathies, not unworthy of a Francis of Assisi.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("Von Rad’s desire was to advance the study of Deuteronomy from a rhetorical and homiletical standpoint. His method was form criticism, worked out with consummate skill in “The Form-Critical Problem of the Hexateuch” (1966b) and "), _c('em', [_vm._v("Studies in Deuteronomy")]), _vm._v(" (1953). Von Rad also initiated a search for Deuteronomy’s "), _c('em', [_vm._v("Sitz im Leben")]), _vm._v(" (“situation in life”), paying particular attention to Deuteronomy 27 and Joshua 24. He concluded that Deuteronomy reflected a covenant renewal ceremony at Shechem, appropriating the view of Adam Welch (1924) that the book’s provenance was northern Israel. But, as we have said, von Rad viewed the preachers behind Deuteronomy’s sermons as post-701 Levitical priests from the Judean countryside (2 Chr 17:7–9). In any case, Deuteronomy contained all the marks of a scroll having been read aloud to a gathered assembly.")])]), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HETORIC AND")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMPOSITION")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("Despite the consuming interest in treaty forms among Deuteronomy scholars of the past half-century, James Muilenburg felt in the 1950s that more work in this homiletical treasure needed to be done along rhetorical lines. He said:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("the large and varied terminology associated with covenantal formulations requires closer attention, the composition and rhetoric and structural forms need to be studied more carefully. (Muilenburg 1959, 348)")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("To some extent it was already being done. In the 1960s, Roman Catholic scholars at the Pontifical Biblical Institute in Rome were applying to the Old Testament a method of rhetorical research practiced earlier in the century by Scripture scholars such as A. Condamin (1905; 1920; 1933), A. Bea, and H. Galbiati (Lohfink 1960, 123 n. 2). Two scholars were engaged in Deuteronomic research: William L. Moran (1969), and Norbert Lohfink (1963a; 1968). On the Protestant side, foundational work on “chiasmus” had been done by University of Chicago—trained Nils W. Lund (1930; 1933; 1942), dean of North Park Theological Seminary in Chicago. The methods these scholars employed were not unlike Muilenburg’s own (1953; 1956; 1969), seeking to locate in the text keyword, motif, and speaker distributions forming inclusios and chiasms (concentric inclusions).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Lohfink (1963b; 1976, 229), in discovering these structures, did not concur with von Rad that Deuteronomy betrayed a “preaching style,” noting that the book’s language had many ties with language of the court and wisdom language, also that the international treaties possessed a rhetorical cast and were meant to be read aloud in solemn public ceremonies. With respect to Deuteronomy’s final composition, Lohfink followed Kleinert (1872, 167) in arguing that the book was an “archive,” its main divisions marked by the headings in 1:1; 4:44; 28:69(29:1); and 33:1 (Lohfink 1962, 32–34; 1968, 7–9; 1976, 229; 1992). Although not giving up entirely the view that Deuteronomy preserved traditions from northern Israel, the accent for Lohfink (1963b) was now upon a written document of Jerusalem origin, not an oral document of northern provenance.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Rhetorical work in Deuteronomy continued apace in the following decades with tangible results, e.g., the work of G. Seitz (1971). The present writer, besides the work noted earlier in connection with the Song of Moses, has shown in other studies that inclusio and framing devices are the controlling structures within Deuteronomy 1–28 (Lundbom 1996) and that a framing mode of composition has been used in Deuteronomy 29–34 (Lundbom 1990). The inclusio and chiasmus, along with other framing devices, are well attested in the poetry and prose of Jeremiah (Lundbom 1975; 1999; 2004a; 2004b), which derive ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("from the same general period. On the method of rhetorical criticism as practiced in the OT generally, and in Jeremiah in particular, see Muilenburg (1969) and Lundbom (1997).")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Rhetorical criticism has advanced our understanding of Deuteronomy’s composition at two important junctures. The summary statements of 4:44–49 and 28:69(29:1) are shown not to be superscriptions, as commonly supposed, but subscriptions, the function of which is to effect closure within the Deuteronomic discourse (Lundbom 1996). There has been ongoing debate whether 28:69 is a superscription or subscription (Nicholson 1967, 21 n. 6), perhaps in part because of the section markings before and after verse 69, and also because some MSS of the LXX, the Vg, and certain English Versions take verse 69 as 29:1. But it never seems to have occurred to earlier critical scholars that 4:44–49 could be a subscription. These verses continued to be viewed as a “second introduction” to the legal material in the book (Nicholson 1967, 19–20). But once it is recognized that the controlling structure in all of Deuteronomy 1–28 is the inclusio, it makes considerably more sense to take both 4:44–49 and 28:69 as forming inclusios with the superscription in 1:1–5 (Lundbom 1996, 302–4, 312–13).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Keywords showing that the summary in 4:44–49 is intended to repeat and create an inclusio with the summary in 1:1–5 are the following:")]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('strong', [_vm._v("Deut 1:1–5")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('strong', [_vm._v("Deut 4:44–49")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("And this is the law")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Moses spoke … all Israel")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Moses spoke … children of Israel")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("beyond the Jordan")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("beyond the Jordan")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Arabah")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Moses … struck down")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sihon king of the Amorites")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sihon king of the Amorites")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("who dwelt in Heshbon")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("who dwelt in Heshbon")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Moses … struck down")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Og king of the Bashan")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Og king of the Bashan")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("beyond the Jordan")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("beyond the Jordan")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  })]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Arabah")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("this law")])])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  })])])])])]), _c('p', {
    staticClass: "BodySb"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Chapters 1–4 are then the proper introduction to the Decalogue and Deuteronomic law, which is what Driver and others have taken them to be ("), _c('em', [_vm._v("pace")]), _vm._v(" Noth), but we must include all of chapter 4, not bracket out 4:44–49 as a “second introduction.” Noth may still be correct in viewing chapters 1–3(4) as an Introduction to the Deuteronomic History, but if so, the chapters take on a dual function: initially introducing the Decalogue and Deuteronomic law, then ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("later introducing the Deuteronomic History once Deuteronomy has been integrated into the Deuteronomic History. This integration will have occurred in the early exile. There is no longer any reason to follow Noth in taking Deuteronomy 1–4 as an exilic work.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In similar fashion, the summary statement in 28:69(29:1) makes another inclusio with the book’s superscription in 1:1–5 (Lundbom 1996, 312–13):")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('em', [_vm._v("These are the words")]), _vm._v(" that "), _c('em', [_vm._v("Moses")]), _vm._v(" spoke to "), _c('em', [_vm._v("all Israel")]), _vm._v(" beyond the Jordan … beyond the Jordan, "), _c('em', [_vm._v("in the land of Moab")]), _vm._v(", Moses sought to make plain "), _c('em', [_vm._v("this law:")]), _vm._v(" (Deut 1:1–5)")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('em', [_vm._v("These are the words of the covenant")]), _vm._v(" that Yahweh commanded "), _c('em', [_vm._v("Moses")]), _vm._v(" to cut with "), _c('em', [_vm._v("the children of Israel in the land of Moab")]), _vm._v(", besides the covenant that he cut with them in Horeb. (Deut 28:69[29:1])")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("The controlling structures in Deuteronomy are rhetorical, dictated by canons of Hebrew rhetoric, known and practiced in the late eighth and early seventh century. With 28:69 taken as a subscription, functioning to bring an initial work on Deuteronomic law and covenant to a conclusion, chapters 1–28 become the first identifiable book of Deuteronomy, herein called the First Edition. A written (Deuteronomic) law is referred to already in 28:58 and 61.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The process from Deuteronomy to Pentateuch can be provisionally sketched as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "HangSb"
  }, [_vm._v("Deuteronomy 1–28 issued in a First Edition, perhaps in Hezekiah’s reign")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deuteronomy 29–30 added as a supplement to the First Edition sometime between the reigns of Hezekiah and Josiah, or in Josiah’s reign")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deuteronomy 31–34 added as a second supplement to the First Edition and Supplement I in Josiah’s reign, after the temple lawbook (the Song of Moses) was found in 622. The Song now becomes Mosaic “law” along with the rest of Deuteronomy (31:26; 32:46)")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Deuteronomy 1–34 made the introduction to the larger Deuteronomic History (Deuteronomy to 2 Kings), completed in the early exile")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Primary History (Genesis to 2 Kings) completed ca. 560")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Pentateuch separated from the Primary History in the postexilic period, and canonized ca. 400")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("On the completion of the Primary History and the separation of the Pentateuch, see Freedman 1962.")])]), _c('h1', {
    staticClass: "sec-1",
    attrs: {
      "id": "sec-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("THE DEUTERONOMIC LAW CODE")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("The book of Deuteronomy contains the Decalogue in 5:6–21, following with its own law code in chapters 12–26, 28. In all of 5–26, 28 preaching is mixed in, with even the laws in 13–18 cast largely in homiletical form. The core of the Deuteronomic Code is casuistic law in chapters 19–25. According to 5:22, only the Decalogue was given to the people at Horeb; the Deuteronomic law was given separately to Moses (5:31), who was now presenting it to Israel in the plains of Moab (1:1–5; 4:44–49). This latter law contained the terms of the covenant made in Moab, to be distinguished from the covenant made at Horeb (28:69[29:1]; cf. 5:2–3). The Deuteronomic Code builds on earlier law in Exodus (JE), but not on Priestly law (P) contained in Exodus, Numbers, and Leviticus. It may indeed know of Priestly law, but does not build on it as systematically presented (Driver 1895, xiv). Deuteronomy also contains parallels with other ancient Near Eastern law, although the major law codes uncovered in excavations thus far are considerably older than Deuteronomy (2200 to 1300), which means one must simply be content with comparisons and contrasts, stopping short of any arguments for dependence of Deuteronomy upon older Near Eastern law.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-10"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARLIER")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBLICAL")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Critical theory has reached a broad consensus that the laws of Deuteronomy build on JE legislation in the book of Exodus. Exodus 20–23 is taken to be a legal collection from the early monarchy, to which the name “Covenant Code” is given. It begins with the Decalogue in Exod 20:1–17. Other important law from this earlier period is contained in Exod 13:3–16 and 34:10–26. The main parallels between the Covenant Code and the Deuteronomic Code are these:")]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 21:1–11")])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Dut 15:12–18")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 22:15–16(22:16–17)")])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 22:28–29")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 22:24–26(22:25–27)")])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 24:10–13")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 23:4–5")])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 22:1–4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 23:8")])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 16:19")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 23:14–19")])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 16:1–17")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exod 23:19b")])]), _vm._v(" "), _c('td', {
    staticClass: "w47"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Deut 14:21b")])])])])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Other overlaps exist. The Covenant Code has more laws dealing with personal injury (Exod 21:18–27) and liabilities relating to animals, personal goods, and property (Exod 21:28–22:14[22:15]) than Deuteronomy. Deuteronomy does not deal with damages or civil suits, which occupy a large part of the Covenant Code. It is concerned rather with protecting human individuals, particularly ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("individuals who have little or no means of protecting themselves (Weinfeld 1961, 243; 1967, 261). The Deuteronomic Code contains only two laws on property: the law prohibiting removal of a landmark (19:14) and the law concerning just weights and measures (25:13–16). Both have parallels in Proverbs (Prov 11:1; 20:10, 23; 22:28; 23:10) and other wisdom literature of the ANE. For a fuller comparison between Deuteronomic law and the laws of Exodus, see Driver 1895, iii–xix; “Deuteronomy” in "), _c('em', [_vm._v("JE")]), _vm._v(", 4:539; Weinfeld, "), _c('em', [_vm._v("EncJud")]), _vm._v(", 5:1579–81.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-11"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATER")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBLICAL")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Priestly laws so-called are found in Exodus, Numbers, and Leviticus. They are concerned largely with cultic practice, which includes sacrifice, purity, and ceremonies of various description. Critical theory recognizes a separate law code in Leviticus 17–26, which has come to be called the “Holiness Code” (H). It is generally agreed that Deuteronomy is not dependent upon the Holiness Code (Driver 1895, xi–xiv; Weinfeld in "), _c('em', [_vm._v("EncJud")]), _vm._v(", 5:1579; Milgrom 1991, 13–35), but whether it antedates all the Priestly legislation in Exodus, Numbers, and Leviticus is a debated question. Scholars following Wellhausen believed that Priestly law, dated to the postexilic period, was later than Deuteronomic law and dependent upon it. But Weinfeld (1972, 179–89) thinks that P and D are concurrent documents emanating from two preexilic literary schools: D from the royal court and P from the temple. Priestly law has a theocentric approach; Deuteronomy is anthropocentric, having its roots in wisdom teaching. For comparisons between Priestly law and Deuteronomy, see Driver 1895, iii–xix; “Deuteronomy” in "), _c('em', [_vm._v("JE")]), _vm._v(", 4:540; Weinfeld 1972, 179–89; Milgrom 1973.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec-2",
    attrs: {
      "id": "sec2-12"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NCIENT")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EAR")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASTERN")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ODES")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Archaeological excavations of the past century and a half have brought to light numerous law codes of the ANE, the major ones being:")]), _vm._v(" "), _c('p', {
    staticClass: "HangSb"
  }, [_vm._v("Code of Ur-Nammu (LUN), of Third Dynasty of Ur (ca. 2050; Good 1967, 2200; cf. "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 523–25; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 408–10)")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Code of Lipit-Ishtar (LI) of Isin (ca. 2017–1985; cf. "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 159–61; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 410–14)")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Laws of Eshnunna (LE), author unknown, reference to King Dadusha in the superscription (ca. 1800; "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 161–63; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 332–35)")]), _vm._v(" "), _c('p', {
    staticClass: "Hang"
  }, [_vm._v("Code of Hammurabi (CH), king of Babylon (ca. 1700; "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 163–80; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 335–53)")])]), _c('p', {
    staticClass: "Hang"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Middle Assyrian Laws (MAL) (ca. 1400; tablets from 1100; "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 180–88; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 353–60)")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "Hang"
  }, [_vm._v("Hittite Laws (HL) (ca. 1300; "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 188–97; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 106–19)")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("To these major codes may be added fragmentary collections of Sumerian laws, e.g., “The Edict of Ammisaduqu” (1646–1626; "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 526–28; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 362–64), and a fragmentary collection of “Neo-Babylonian Laws” (635–539; "), _c('em', [_vm._v("ANET")]), _c('sup', [_vm._v("3")]), _vm._v(", 197–98; "), _c('em', [_vm._v("COS")]), _vm._v(" 2, 360–61). Older English works exist on (1) Laws of Eshnunna: Yaron (1969); (2) Old Babylonian and Neo-Babylonian laws: Johns (1904; 1914) and G. R. Driver and Miles (1952; 1955); (3) Assyrian laws: G. R. Driver and Miles (1935); and (4) Hittite laws: Neufeld (1951).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Study of these ancient nonbiblical law codes has brought to light two basic types of law in the OT: apodictic law and casuistic law. The important work here was done by Albrecht Alt. Alt noted that most of the Ten Commandments contain the second singular “you” together with an emphatic and unconditional “not” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("לֹא")]), _vm._v("), which makes them apodictic in form (Alt 1966c, 117–23). Commandments on keeping the Sabbath and honoring one’s parents are positive, and also stated differently. The same obtains in the Decalogue of the Covenant Code. Other laws in Deuteronomy and the Covenant Code, also in law codes of the ANE, are stated in casuistic form: “If someone does such and such, then such and such will be the punishment” (Alt 1966c, 88–103). “The ordinances” ("), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מִּשְׁפָּטִים")]), _vm._v(") of the Covenant Code (Exod 21:1) are casuistic law, beginning most often with the conjunction "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("כִּי")]), _vm._v(" (“when”). Casuistic laws in Deuteronomy 24–25 occur in the midst of apodictic laws (24:14–16; 25:4, 13–14). Casuistic laws are suited for use in a court of law. Apodictic law, more absolute than law containing provisions for punishment, has no parallel in Mesopotamian law. Alt believed that apodictic law was distinctly Israelite and that casuistic law was taken over from the Canaanites after Israel’s settlement in the land.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df05e37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Introduction.vue
// module id = 78
// module chunks = 0